





































































































































































































































































/** fullName пересобираем только при правке полей имени: разбор строки на части приблизителен */
import { AxiosResponse, CancelTokenSource } from 'axios';
import { Component, Mixins, Prop, Watch } from 'vue-property-decorator';

import Toast from '@/mixins/toast';

import MmHintedButton from '../../components/MmHintedButton.vue';
import { createAuditor, MmAuditorMessengerPayload, MmAuditorPayload, updateAuditor } from '../../api/auditors';
import { createCancelSource } from '../../api/mmHttp';
import { MM_AUDITOR_CONTACTS_IN_PAYLOAD, MM_AUDITOR_NAME_PARTS_IN_PAYLOAD } from '../../config/features';
import { joinFullName, MmAuditorNameParts, normalizeSpaces, parseFullName } from '../../core/auditorName';
import { copyTextToClipboard } from '../../core/download';
import { isCanceled, toMmError } from '../../core/errors';
import { MmAuditor, MmAuditorMessenger } from '../../types/domain';
import { MmAuditorCreated } from '../../types/dto';
import { MM_MESSENGER_TITLES, MM_MESSENGERS, MM_MESSENGERS_WITH_USERNAME } from '../../types/enums';
import AuditorMessengerSendMixin from './auditorMessengerSendMixin';

const KEY = 'priceMonitoring.mobileMonitoring.auditors.';

/** Пределы длины полей повторяют ограничения колонок и контракт мобильного бэкенда */
const FULL_NAME_MAX_LENGTH = 255;
const NAME_PART_MAX_LENGTH = 64;
const LOGIN_MIN_LENGTH = 3;
const LOGIN_MAX_LENGTH = 40;
const PHONE_MAX_LENGTH = 20;
const USERNAME_MAX_LENGTH = 64;

/** Маска повторяет контракт: дефис стоит последним, иначе он задаёт диапазон; флаг i добавлять нельзя */
const LOGIN_PATTERN = /^[a-z0-9._-]+$/;

const LOGIN_TAKEN_CODE = 'login_already_exists';

const LOGIN_TAKEN_CODES = [LOGIN_TAKEN_CODE, 'login_taken', 'auditor_login_already_exists'];

function isLoginTakenCode(serverCode: string | null): boolean {
	return serverCode !== null && LOGIN_TAKEN_CODES.indexOf(serverCode) >= 0;
}

const EMAIL_TAKEN_CODES = ['email_taken'];

function isEmailTakenCode(serverCode: string | null): boolean {
	return serverCode !== null && EMAIL_TAKEN_CODES.indexOf(serverCode) >= 0;
}

/** Имена полей формы, а не провода: забытое имя уведёт ошибку бэкенда в общий тост */
const FIELD_NAMES = ['fullName', 'lastName', 'firstName', 'middleName', 'login', 'email', 'phone'];

const FORM_FIELD_NAMES = ['lastName', 'firstName', 'middleName', 'login', 'email', 'phone'];

/** Маска нарочно мягкая: строгая проверка отсекает рабочие адреса, окончательно проверяет бэкенд */
const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

/** Проверка нарочно мягкая: поле необязательное, 15 цифр — предел E.164, дальше проверяет бэкенд */
const PHONE_ALLOWED_PATTERN = /^[0-9+\-() ]+$/;
const PHONE_MIN_DIGITS = 10;
const PHONE_MAX_DIGITS = 15;

function countDigits(value: string): number {
	const matched = value.match(/[0-9]/g);

	return matched === null ? 0 : matched.length;
}

interface MmAuditorMessengersForm {
	selected: string[];
	usernames: { [code: string]: string };
}

interface MmAuditorFormFields {
	lastName: string;
	firstName: string;
	middleName: string;
	login: string;
	email: string;
	phone: string;
	messengers: MmAuditorMessengersForm;
}

interface MmAuditorFieldMap {
	[field: string]: string;
}

/** Все ключи задаём сразу: добавленные позже поля Vue не сделает реактивными */
function createEmptyErrors(): MmAuditorFieldMap {
	return { fullName: '', lastName: '', firstName: '', middleName: '', login: '', email: '', phone: '' };
}

function createTouched(value: boolean): { [field: string]: boolean } {
	return {
		lastName: value,
		firstName: value,
		middleName: value,
		login: value,
		email: value,
		phone: value,
	};
}

@Component({
	components: { MmHintedButton },
})
export default class AuditorFormModal extends Mixins(Toast, AuditorMessengerSendMixin) {
	@Prop({ default: false }) readonly visible!: boolean;

	/** `null` — режим создания; объект — режим правки. */
	@Prop({ default: null }) readonly auditor!: MmAuditor | null;

	@Prop({ default: null }) readonly tradingId!: number | null;

	form: MmAuditorFormFields = {
		lastName: '',
		firstName: '',
		middleName: '',
		login: '',
		email: '',
		phone: '',
		messengers: { selected: [], usernames: {} },
	};

	serverErrors: MmAuditorFieldMap = createEmptyErrors();

	touched: { [field: string]: boolean } = createTouched(false);

	isSaving: boolean = false;

	isPasswordVisible: boolean = false;

	temporaryPassword: string = '';

	createdLogin: string = '';

	/** Исходное значение нужно, чтобы не перезаписать ФИО, которое пользователь не менял */
	private originalFullName: string = '';

	private parsedSnapshot: MmAuditorNameParts = { lastName: '', firstName: '', middleName: '', confident: true };

	private nameParseConfident: boolean = true;

	/** Не тронутое пользователем значение с сервера маской не проверяем: иначе запись не отредактировать */
	private originalEmail: string = '';

	private originalPhone: string = '';

	/** В axios 0.18 нет AbortController — только CancelToken */
	private cancelSource: CancelTokenSource | null = null;

	/* Константы модуля шаблону не видны: каждая упомянутая в разметке нуждается в геттере */

	get NAME_PART_MAX_LENGTH(): number {
		return NAME_PART_MAX_LENGTH;
	}

	get LOGIN_MAX_LENGTH(): number {
		return LOGIN_MAX_LENGTH;
	}

	get PHONE_MAX_LENGTH(): number {
		return PHONE_MAX_LENGTH;
	}

	get USERNAME_MAX_LENGTH(): number {
		return USERNAME_MAX_LENGTH;
	}

	get isEditMode(): boolean {
		return this.auditor !== null;
	}

	get modalTitle(): string {
		return this.$t(KEY + (this.isEditMode ? 'formEditTitle' : 'formCreateTitle')) as string;
	}

	get lastNameLabel(): string {
		return this.$t(KEY + 'fieldLastName') as string;
	}

	get firstNameLabel(): string {
		return this.$t(KEY + 'fieldFirstName') as string;
	}

	get middleNameLabel(): string {
		return this.$t(KEY + 'fieldMiddleName') as string;
	}

	get loginLabel(): string {
		return this.$t(KEY + 'fieldLogin') as string;
	}

	get emailLabel(): string {
		return this.$t(KEY + 'fieldEmail') as string;
	}

	get phoneLabel(): string {
		return this.$t(KEY + 'fieldPhone') as string;
	}

	/** Пример телефона одинаков во всех локалях: формат задаёт страна установки, а не язык */
	get phonePlaceholder(): string {
		return this.$t(KEY + 'fieldPhonePlaceholder') as string;
	}

	get messengersLabel(): string {
		return this.$t(KEY + 'sectionMessengers') as string;
	}

	get loginDescription(): string {
		return this.isEditMode ? (this.$t(KEY + 'fieldLoginReadonlyHint') as string) : '';
	}

	get saveText(): string {
		return this.$t('shared.actions.save') as string;
	}

	get cancelText(): string {
		return this.$t('shared.actions.cancel') as string;
	}

	get cancelDisabledReason(): string {
		return this.$t('priceMonitoring.mobileMonitoring.states.loading') as string;
	}

	get closeText(): string {
		return this.$t('shared.actions.close') as string;
	}

	get passwordTitle(): string {
		return this.$t(KEY + 'tempPasswordTitle') as string;
	}

	get passwordText(): string {
		return this.$t(KEY + 'tempPasswordText') as string;
	}

	get passwordOnceText(): string {
		return this.$t(KEY + 'tempPasswordOnce') as string;
	}

	get passwordCopyText(): string {
		return this.$t(KEY + 'tempPasswordCopy') as string;
	}

	get copyAllText(): string {
		return this.$t('priceMonitoring.mobileMonitoring.common.copyAll') as string;
	}

	get hasPassword(): boolean {
		return this.temporaryPassword !== '';
	}

	get credentialsCopyText(): string {
		const passwordLabel = this.$t('users.form.password') as string;

		return this.loginLabel + ': ' + this.createdLogin + '\n' + passwordLabel + ': ' + this.temporaryPassword;
	}

	get messengerSendLogin(): string {
		return this.createdLogin;
	}

	get messengerSendPassword(): string {
		return this.temporaryPassword;
	}

	get messengerSendMessengers(): MmAuditorMessenger[] | null {
		if (!this.hasPassword) {
			return null;
		}

		const payload = this.buildMessengersPayload();

		return payload.length > 0 ? payload : [];
	}

	get messengerSendPhone(): string | null {
		const phone = normalizeSpaces(this.form.phone);

		return phone === '' ? null : phone;
	}

	get nameParseNote(): string {
		return this.$t(KEY + 'nameParseNote', { value: this.originalFullName }) as string;
	}

	get hasAmbiguousName(): boolean {
		return this.isEditMode && !this.nameParseConfident;
	}

	get isContactsEnabled(): boolean {
		return MM_AUDITOR_CONTACTS_IN_PAYLOAD;
	}

	/** slice обязателен: без него наружу уходит общий на весь раздел массив */
	get messengerOptions(): string[] {
		return (MM_MESSENGERS as string[]).slice();
	}

	messengerTitle(code: string): string {
		const title = MM_MESSENGER_TITLES[code];

		return title === undefined ? code : title;
	}

	messengerUsername(code: string): string {
		const value = this.form.messengers.usernames[code];

		return value === undefined || value === null ? '' : String(value);
	}

	/** У Viber нет публичных никнеймов, поэтому его отметка не добавляет ни одного поля */
	get usernameFields(): Array<{ code: string; label: string }> {
		const withUsername = MM_MESSENGERS_WITH_USERNAME as string[];
		const result: Array<{ code: string; label: string }> = [];

		for (let i = 0; i < withUsername.length; i += 1) {
			const code = withUsername[i];

			if (this.form.messengers.selected.indexOf(code) === -1) {
				continue;
			}

			result.push({
				code: code,
				label: this.$t(KEY + 'fieldMessengerUsername', { messenger: this.messengerTitle(code) }) as string,
			});
		}

		return result;
	}

	/** a-checkbox-group отдаёт массив значений, а не событие — в отличие от a-input в этом же файле */
	handleMessengersChange(codes: string[]): void {
		const next = codes === null || codes === undefined ? [] : codes;

		this.form.messengers.selected = next;

		/** Снятая галочка чистит никнейм; удаляем через $delete — Vue 2 не видит штатного delete */
		const known = Object.keys(this.form.messengers.usernames);

		for (let i = 0; i < known.length; i += 1) {
			if (next.indexOf(known[i]) === -1) {
				this.$delete(this.form.messengers.usernames, known[i]);
			}
		}
	}

	onUsernameInput(code: string, value: string): void {
		// $set, а не присваивание: Vue 2 не замечает появления нового ключа объекта
		this.$set(
			this.form.messengers.usernames,
			code,
			value === null || value === undefined ? '' : String(value),
		);
	}

	/** Формат логина, e-mail и телефона проверяем только у изменённых полей — иначе запись не сохранить */
	get validation(): MmAuditorFieldMap {
		const errors = createEmptyErrors();
		const lastName = normalizeSpaces(this.form.lastName);
		const firstName = normalizeSpaces(this.form.firstName);
		const middleName = normalizeSpaces(this.form.middleName);
		const login = normalizeSpaces(this.form.login);
		const email = normalizeSpaces(this.form.email);
		const phone = normalizeSpaces(this.form.phone);

		if (lastName === '') {
			errors.lastName = this.$t(KEY + 'errRequiredLastName') as string;
		} else {
			/** Через интерфейс предел недостижим, но с сервера ФИО могло приехать длиннее */
			const joined = joinFullName({ lastName: lastName, firstName: firstName, middleName: middleName });

			if (joined.length > FULL_NAME_MAX_LENGTH) {
				errors.lastName = this.$t(KEY + 'errTooLong', { max: FULL_NAME_MAX_LENGTH }) as string;
			}
		}

		if (firstName === '' && this.isFirstNameRequired) {
			errors.firstName = this.$t(KEY + 'errRequiredFirstName') as string;
		}

		if (login === '') {
			errors.login = this.$t(KEY + 'errRequiredLogin') as string;
		} else if (!this.isEditMode) {
			/** Формат и длину логина проверяем только при создании: в правке в поле лежит склеенный логин */
			if (/\s/.test(login)) {
				errors.login = this.$t(KEY + 'errLoginSpaces') as string;
			} else if (!LOGIN_PATTERN.test(login)) {
				errors.login = this.$t(KEY + 'errLoginFormat') as string;
			} else if (login.length < LOGIN_MIN_LENGTH) {
				errors.login = this.$t(KEY + 'errTooShort', { min: LOGIN_MIN_LENGTH }) as string;
			} else if (login.length > LOGIN_MAX_LENGTH) {
				errors.login = this.$t(KEY + 'errTooLong', { max: LOGIN_MAX_LENGTH }) as string;
			}
		}

		if (email !== '' && email !== this.originalEmail && !EMAIL_PATTERN.test(email)) {
			errors.email = this.$t(KEY + 'errEmailFormat') as string;
		}

		if (phone !== '' && phone !== this.originalPhone) {
			const digits = countDigits(phone);

			if (!PHONE_ALLOWED_PATTERN.test(phone) || digits < PHONE_MIN_DIGITS || digits > PHONE_MAX_DIGITS) {
				errors.phone = this.$t(KEY + 'errPhoneFormat') as string;
			}
		}

		return errors;
	}

	/** В правке имя обязательно, только если оно было непустым при открытии; при создании — всегда */
	get isFirstNameRequired(): boolean {
		if (!this.isEditMode) {
			return true;
		}

		return this.parsedSnapshot.firstName !== '';
	}

	get isFormValid(): boolean {
		const errors = this.validation;

		for (let i = 0; i < FORM_FIELD_NAMES.length; i += 1) {
			if (errors[FORM_FIELD_NAMES[i]] !== '') {
				return false;
			}
		}

		return true;
	}

	get isSaveDisabled(): boolean {
		return !this.isFormValid || this.tradingId === null;
	}

	get saveDisabledReason(): string {
		if (this.tradingId === null) {
			return this.$t(KEY + 'createDisabledNoNetwork') as string;
		}

		return this.$t(KEY + 'saveDisabledHint') as string;
	}

	/** Серверную ошибку по fullName показываем у поля «Фамилия» — иначе у неё нет адресата */
	fieldError(field: string): string {
		const fromServer = field === 'lastName'
			? this.firstNonEmpty(this.serverErrors.lastName, this.serverErrors.fullName)
			: this.serverErrors[field];

		if (fromServer !== undefined && fromServer !== '') {
			return String(fromServer);
		}

		if (this.touched[field] !== true) {
			return '';
		}

		const fromValidation = this.validation[field];

		return fromValidation === undefined ? '' : String(fromValidation);
	}

	hasFieldError(field: string): boolean {
		return this.fieldError(field) !== '';
	}

	fieldStatus(field: string): string {
		return this.hasFieldError(field) ? 'error' : '';
	}

	/** Идентификатор строится от _uid компонента: две формы на странице дали бы одинаковые id */
	errorId(field: string): string {
		return 'sm-mobilemon-auditor-' + field + '-error-' + String((this as any)._uid);
	}

	fieldId(field: string): string {
		return 'sm-mobilemon-auditor-' + field + '-' + String((this as any)._uid);
	}

	/** Сбрасываем только при открытии: содержимое переживает закрытие, а окно успеха живёт позже */
	@Watch('visible')
	onVisibleChanged(next: boolean): void {
		if (next) {
			this.resetForm();
		}
	}

	beforeDestroy(): void {
		this.cancelPendingRequest();
	}

	/** Значение здесь не преобразуем: ant делает ранний выход при совпадении, и поле разойдётся */
	onFieldInput(field: string, value: string): void {
		(this.form as any)[field] = value === null || value === undefined ? '' : String(value);
		this.$set(this.serverErrors, field, '');
		this.$set(this.touched, field, false);

		if (field === 'lastName' || field === 'firstName' || field === 'middleName') {
			this.$set(this.serverErrors, 'fullName', '');
		}
	}

	onFieldBlur(field: string): void {
		this.$set(this.touched, field, true);
	}

	/** Отмена во время сохранения запрещена: аудитор уже создан, а пароль показывается один раз */
	handleCancel(): void {
		if (this.isSaving) {
			return;
		}

		this.cancelPendingRequest();
		this.$emit('cancel');
	}

	handleSubmit(): void {
		if (this.isSaving || this.tradingId === null) {
			return;
		}

		if (!this.isFormValid) {
			this.touchAllFields();

			return;
		}

		const editing = this.auditor;
		const payload = this.buildPayload();

		this.cancelPendingRequest();

		const source = createCancelSource();

		this.cancelSource = source;
		this.isSaving = true;
		const request: Promise<AxiosResponse<any>> = editing !== null
			? updateAuditor(editing.id, payload, { cancelToken: source.token })
			: createAuditor(payload, { cancelToken: source.token });

		request
			.then((response) => {
				this.cancelSource = null;
				this.isSaving = false;

				if (editing !== null) {
					this.showInfo(this.$t(KEY + 'updatedToast') as string);
					this.$emit('updated', response.data as MmAuditor);

					return;
				}

				this.handleCreated(response.data as MmAuditorCreated, payload.login);
			})
			.catch((error) => {
				if (isCanceled(error)) {
					return;
				}

				this.cancelSource = null;
				this.isSaving = false;
				this.applySaveError(error);
			});
	}

	private buildPayload(): MmAuditorPayload {
		const editing = this.auditor;
		const lastName = normalizeSpaces(this.form.lastName);
		const firstName = normalizeSpaces(this.form.firstName);
		const middleName = normalizeSpaces(this.form.middleName);
		const email = normalizeSpaces(this.form.email);
		const phone = normalizeSpaces(this.form.phone);

		const joined = joinFullName({ lastName: lastName, firstName: firstName, middleName: middleName });
		const isNameTouched = this.isNameTouchedByUser();
		const fullName = isNameTouched ? joined : this.originalFullName;

		const payload: MmAuditorPayload = {
			login: normalizeSpaces(this.form.login),
			fullName: fullName,
			email: email === '' ? null : email,
			phone: phone === '' ? null : phone,
			/** PUT заменяет запись целиком, поэтому ключ region обязан быть в теле всегда — иначе он сотрётся */
			region: editing !== null && editing.region !== undefined ? editing.region : null,
			tradingNetworkId: this.tradingId as number,
		};

		if (MM_AUDITOR_NAME_PARTS_IN_PAYLOAD) {
			/** Неуверенный разбор ФИО не отправляем: null означает «оставить как было», а не очистку */
			const sendsParts = isNameTouched || this.nameParseConfident;

			payload.lastName = sendsParts && lastName !== '' ? lastName : null;
			payload.firstName = sendsParts && firstName !== '' ? firstName : null;
			payload.middleName = sendsParts && middleName !== '' ? middleName : null;
		}

		if (MM_AUDITOR_CONTACTS_IN_PAYLOAD) {
			payload.messengers = this.buildMessengersPayload();
		} else if (editing !== null) {
			/** PUT заменяет запись целиком: без переноса мессенджеров сохранение обнулило бы их в базе */
			const kept = editing.messengers;

			if (kept !== null && kept !== undefined) {
				payload.messengers = kept.slice();
			}
		}

		return payload;
	}

	private buildMessengersPayload(): MmAuditorMessengerPayload[] {
		const codes = MM_MESSENGERS as string[];
		const withUsername = MM_MESSENGERS_WITH_USERNAME as string[];
		const result: MmAuditorMessengerPayload[] = [];

		for (let i = 0; i < codes.length; i += 1) {
			const code = codes[i];

			if (this.form.messengers.selected.indexOf(code) === -1) {
				continue;
			}

			// У Viber никнейма нет, поэтому null, а не пустая строка
			if (withUsername.indexOf(code) === -1) {
				result.push({ type: code, username: null });

				continue;
			}

			const raw = this.form.messengers.usernames[code];
			const username = raw === undefined || raw === null ? '' : String(raw).trim();

			result.push({ type: code, username: username === '' ? null : username });
		}

		return result;
	}

	/** Сравниваем с разобранными значениями, снятыми при открытии, а не с исходной строкой */
	private isNameTouchedByUser(): boolean {
		return normalizeSpaces(this.form.lastName) !== this.parsedSnapshot.lastName
			|| normalizeSpaces(this.form.firstName) !== this.parsedSnapshot.firstName
			|| normalizeSpaces(this.form.middleName) !== this.parsedSnapshot.middleName;
	}

	private handleCreated(created: MmAuditorCreated, sentLogin: string): void {
		const password = created && created.temporaryPassword !== null && created.temporaryPassword !== undefined
			? String(created.temporaryPassword)
			: '';

		if (password !== '') {
			this.temporaryPassword = password;
			this.createdLogin = created && created.login ? String(created.login) : sentLogin;
			this.isPasswordVisible = true;
		} else {
			this.showInfo(this.$t(KEY + 'createdToast') as string);
		}

		this.$emit('created', created);
	}

	private applySaveError(error: any): void {
		const mmError = toMmError(error, 'auditors/form');

		if (isLoginTakenCode(mmError.serverCode)) {
			this.$set(this.serverErrors, 'login', this.$t(KEY + 'errLoginTaken') as string);

			return;
		}

		if (isEmailTakenCode(mmError.serverCode)) {
			this.$set(this.serverErrors, 'email', this.$t(KEY + 'errEmailTaken') as string);

			return;
		}

		if (this.applyFieldDetails(error)) {
			return;
		}

		const message = mmError.message !== '' ? mmError.message : (this.$t(mmError.i18nKey) as string);

		this.showError(message);
	}

	/** Массив ошибок в словарь превращает транспортный слой — второго разбора здесь не заводим */
	private applyFieldDetails(error: any): boolean {
		const response = error && error.response ? error.response : null;
		const body = response ? response.data : null;

		if (!body || typeof body !== 'object') {
			return false;
		}

		const details = body.details && typeof body.details === 'object'
			? body.details
			: (body.fieldErrors && typeof body.fieldErrors === 'object' ? body.fieldErrors : null);

		if (details === null) {
			return false;
		}

		let applied = false;

		for (let i = 0; i < FIELD_NAMES.length; i += 1) {
			const field = FIELD_NAMES[i];
			const text = details[field];

			if (typeof text === 'string' && text !== '') {
				this.$set(this.serverErrors, field, text);
				applied = true;
			}
		}

		return applied;
	}

	copyPassword(): void {
		if (!this.hasPassword) {
			return;
		}

		if (copyTextToClipboard(this.temporaryPassword)) {
			this.showInfo(this.$t(KEY + 'tempPasswordCopied') as string);
		}
	}

	copyAll(): void {
		if (!this.hasPassword) {
			return;
		}

		if (copyTextToClipboard(this.credentialsCopyText)) {
			this.showInfo(this.$t(KEY + 'tempPasswordCopied') as string);
		}
	}

	closePasswordModal(): void {
		this.isPasswordVisible = false;
		this.temporaryPassword = '';
		this.createdLogin = '';
	}

	private resetForm(): void {
		const source = this.auditor;
		const parsed = this.readNameParts(source);

		this.originalFullName = source !== null ? String(source.fullName) : '';
		this.parsedSnapshot = parsed;
		this.nameParseConfident = parsed.confident;

		const initialEmail = source !== null && source.email !== null ? String(source.email) : '';
		const initialPhone = source !== null && source.phone !== null ? String(source.phone) : '';

		this.originalEmail = normalizeSpaces(initialEmail);
		this.originalPhone = normalizeSpaces(initialPhone);

		this.form = {
			lastName: parsed.lastName,
			firstName: parsed.firstName,
			middleName: parsed.middleName,
			login: source !== null ? String(source.login) : '',
			email: initialEmail,
			phone: initialPhone,
			messengers: this.readMessengers(source),
		};
		this.serverErrors = createEmptyErrors();
		this.touched = createTouched(false);
		this.isSaving = false;
	}

	private readNameParts(source: MmAuditor | null): MmAuditorNameParts {
		if (source === null) {
			return { lastName: '', firstName: '', middleName: '', confident: true };
		}

		const rawLastName = source.lastName;

		if (rawLastName !== null && rawLastName !== undefined && String(rawLastName).trim() !== '') {
			const rawFirstName = source.firstName;
			const rawMiddleName = source.middleName;

			return {
				lastName: String(rawLastName).trim(),
				firstName: rawFirstName !== null && rawFirstName !== undefined ? String(rawFirstName).trim() : '',
				middleName: rawMiddleName !== null && rawMiddleName !== undefined ? String(rawMiddleName).trim() : '',
				confident: true,
			};
		}

		return parseFullName(String(source.fullName));
	}

	/** Неизвестный код мессенджера форма не показывает и, значит, не сохраняет обратно */
	private readMessengers(source: MmAuditor | null): MmAuditorMessengersForm {
		const result: MmAuditorMessengersForm = { selected: [], usernames: {} };

		if (source === null || source.messengers === null || source.messengers === undefined) {
			return result;
		}

		const list = source.messengers;
		const codes = MM_MESSENGERS as string[];
		const withUsername = MM_MESSENGERS_WITH_USERNAME as string[];

		for (let i = 0; i < codes.length; i += 1) {
			const code = codes[i];

			for (let j = 0; j < list.length; j += 1) {
				const item = list[j];

				if (!item || String(item.type).toUpperCase() !== code) {
					continue;
				}

				result.selected.push(code);

				if (withUsername.indexOf(code) !== -1 && item.username !== null && item.username !== undefined) {
					result.usernames[code] = String(item.username);
				}

				break;
			}
		}

		return result;
	}

	private touchAllFields(): void {
		this.touched = createTouched(true);
	}

	private firstNonEmpty(first: string | undefined, second: string | undefined): string {
		if (first !== undefined && first !== '') {
			return first;
		}

		return second === undefined ? '' : second;
	}

	private cancelPendingRequest(): void {
		if (this.cancelSource !== null) {
			this.cancelSource.cancel();
			this.cancelSource = null;
		}
	}
}
